import { Dialog } from '@busybusy/webapp-react-ui';
import { ClockInRestrictionType } from '__generated__/graphql';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import useClockInRestrictionTimeConverter from 'hooks/models/position/useClockInRestrictionTimeConverter';
import { useMemo } from 'react';
import IPosition from 'types/Position';
import { useFeatureFlags } from 'utils/features';
import { t } from 'utils/localize';
import ClockInRestrictionForm from '../forms/ClockInRestrictionForm';

export interface IClockInRestrictionDetailProps {
  editable: boolean;
  position: IPosition;
  onUpdate: () => Promise<any>;
  className?: ClassName;
}

function ClockInRestrictionDetail({ position, onUpdate, editable, className }: IClockInRestrictionDetailProps) {
  const editTitleDialog = useOpenable();
  const { fromClockInRestriction } = useClockInRestrictionTimeConverter();
  const clockInRestrictionToggled = useFeatureFlags('CLOCK_IN_RESTRICTION');
  const currentSetting = useMemo(
    () => ({
      clockInRestriction: position.clockInRestriction ?? ClockInRestrictionType.Off,
      clockInRestrictionStartTime: fromClockInRestriction(position.clockInRestrictionStartTime),
    }),
    [fromClockInRestriction, position]
  );
  function getPositionValue() {
    if (position.clockInRestriction === ClockInRestrictionType.Time) {
      return t('Start Time') + ` (${fromClockInRestriction(position.clockInRestrictionStartTime).toFormat('t')})`;
    } else if (position.clockInRestriction === ClockInRestrictionType.Schedule) {
      return t('Schedule Only');
    } else {
      return t('Off');
    }
  }

  function onSubmit() {
    editTitleDialog.close();
    onUpdate();
  }

  const classes = classNames('clock-in-restriction-detail', className);

  return (
    <>
      <ProDetailsItem
        title={t('Clock-In Restriction')}
        onClick={editTitleDialog.open}
        value={getPositionValue()}
        hint={t('Prevent employees from clocking in before a specified time, or without a scheduled work item.')}
        className={classes}
        disabled={!editable || !clockInRestrictionToggled}
      />
      <Dialog position={'center'} isOpen={editTitleDialog.isOpen} onClose={editTitleDialog.close}>
        <ClockInRestrictionForm
          className="mt-4 p-8"
          onSubmit={onSubmit}
          positionId={position.id}
          currentSetting={currentSetting}
        />
      </Dialog>
    </>
  );
}

export default ClockInRestrictionDetail;
